import styled from 'styled-components'
import { Box, Typography } from 'src/components'
import { Link } from 'react-router-dom'

export const Container = styled(Box)<{ width: string; widthTablet: string }>`
    width: 100%;
    background: ${({ theme }) => theme.colors.fontImage};
    display: flex;
    justify-content: center;
    height: 216px;
    align-items: end;
    position: relative;
    cursor: pointer;
    margin-bottom: 12px;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: ${({ widthTablet }) => widthTablet};
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        width: ${({ width }) => width};
        height: 316px;
    }
`
export const StyledLink = styled(Link)`
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: end;
    color: ${({ theme }) => theme.colors.white};
    justify-content: center;
`
export const Image = styled.img`
    width: 100%;
    height: 50%;
    position: relative;
    object-fit: cover;
`

export const ContentInformation = styled(Box)`
    height: 45%;
    position: relative;
    display: flex;
    background: #333333;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
`
export const TitleTypography = styled(Typography)`
    font-family: inherit;
    font-style: normal;
    text-align: start;
    line-height: 110.9%;
    text-decoration: none;
    display: -webkit-box;
    width: 95%;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    color: ${({ theme }) => theme.colors.white};
    :hover {
        color: ${({ theme }) => theme.colors.white};
    }
    :active {
        color: ${({ theme }) => theme.colors.white};
    }
`
export const OverSpan = styled.span`
    position: absolute;
    background-size: cover;
    background-position: center center;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0.8;
    background-image: linear-gradient(
        0deg,
        rgba(0, 0, 0, 0.6),
        rgba(0, 0, 0, 0.6)
    );
`
export const DateAndCreation = styled(Box)`
    width: 95%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: start;
`
export const ContentData = styled(Box)`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 20%;
`
export const ContentDataTitle = styled(Box)`
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: space-around;
    height: 80%;
`
export const ImageIcon = styled.img`
    width: 15px;
    height: 15px;
    object-fit: contain;
    margin-right: 4px;
`
export const TypographyDate = styled(Typography)`
    font-family: inherit;
    font-style: normal;
    line-height: 110.9%;
    text-decoration: none;
    color: ${({ theme }) => theme.colors.white};
    :hover {
        color: ${({ theme }) => theme.colors.white};
    }
    :active {
        color: ${({ theme }) => theme.colors.white};
    }
`
